import React from "react"
import { HandleImages } from "../../components/functions"
import Layout from "../../components/layout"
import "../../css/terms.css"
import SEO from "../../components/seo"
import ActOnNew from "../../components/act-on/act-on-new"
import { Link } from "gatsby"

function CheckMark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22.46 22.46"
      height="15"
      width="15"
      style={{ marginRight: 5 }}
    >
      <g data-name="Layer 2">
        <g data-name="Layer 1">
          <circle cx="11.23" cy="11.23" r="11.23" fill="#4fafe2" />
          <path
            fill="#fff"
            d="M9.35 16.52l-4.7-4.7 1.41-1.41 3.29 3.29 7.05-7.06 1.41 1.42-8.46 8.46z"
          />
        </g>
      </g>
    </svg>
  )
}

class Cancel extends React.Component {
  render() {
    return (
      <Layout>
        <SEO
          title="Contact Us"
          description="Interested in learning more about cybersecurity learning and assessment solutions for your organization? Contact us to schedule a free demo."
        />
        <div className="mainContainer gray" style={{ padding: "60px 0" }}>
          <div className="centeredContainer">
            <div className="headerImage">
              <HandleImages name="womanSportsCoat" />
            </div>
            <div className="headerCTAs">
              <div className="titleText">
                <h2>Connect With Us</h2>
                <p>
                  Looking for information about Circadence and Project Ares?
                  Check out the following links and forms.
                </p>
              </div>
              <button className="cta-block">
                  
              <Link to="/contact/sales">
                <h4>Contact Sales</h4>
                <p>
                  Need help? We’re here to answer questions, demo Project Ares,
                  and recommend the right solution for you or your organization.
                  Contact us through the form below.
                </p></Link>
              </button>
              <button className="cta-block">
                <Link to="/faq">
                  <h4>Frequently Asked Questions</h4>
                  <p>
                    Getting started with the Project Ares learning platform?
                    We’ve got a list of common questions on our FAQ page to help
                    you..
                  </p>
                </Link>
              </button>
              <button className="cta-block">
              <Link to="/contact/support">
                <h4>Contact Support</h4>
                <p>
                  Already a Project Ares customer? Our Customer Support team is
                  available to assist with questions or issues you may have.
                  Email them through the form below.
                </p></Link>
              </button>
              <button className="cta-block">
                <a
                  target="__blank"
                  href="https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00f8/t/page/fm/0"
                >
                  <h4>Partner With Us</h4>
                  <p>
                    We’re always looking for quality partners to join our
                    mission to create a more effective cyber workforce. Learn
                    more about our partner program.
                  </p>
                </a>
              </button>
            </div>
          </div>
        </div>

        <div className="mainContainer" style={{ paddingTop: 30 }}>
          <div id="body-content" className="centeredContainer wrap">
            <div style={{ flexBasis: "100%" }}>
              <h2>Email the Circadence support desk</h2>
              <hr />
            </div>
            <div id="form-content" class="basicFlex nowrap" style={{marginTop:"20px"}}>
            <div
              id="bullets-container"
              style={{ flexGrow: 1, marginRight: 20 }}
            >
              <h4 style={{ marginBottom: "20px" }}>
                Our support team is here to help
              </h4>
              <div className="inlineList">
                <CheckMark />
                <p>Share your ideas and suggestions</p>
              </div>
              <div className="inlineList">
                <CheckMark />
                <p>Contact us about platform issues</p>
              </div>
             
            </div>
            <ActOnNew id="d38bb6e7-355b-45f9-bc09-30488a72d805" />
        
            
            
            </div>
          </div>{" "}
        </div>
       
      </Layout>
    )
  }
}

export default Cancel
